<template>
  <view-projects />
</template>

<script>
import ViewProjects from "@/components/Projects/ViewProjects";
export default {
  name: "ProjectView",
  components: {
    "view-projects": ViewProjects,
  },
};
</script>

<style scoped></style>
